"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var externalUrl = exports.externalUrl = /(^\w+:)|(^\/\/)/;
var singleLocalePrefixAndRest = exports.singleLocalePrefixAndRest = /^(\/(\w+))(.*)/g;
var doubleLocalePrefixAndRest = exports.doubleLocalePrefixAndRest = /^(\/(\w+)-(\w+))(.*)/gi;